import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTenant } from '../../context/TenantContext';
import { Loading } from '../common';

const ManagerRoute = ({ children }) => {
  const { user, isAdmin, isManager, managerCompanyId, loading } = useAuth();
  const { companyId } = useTenant();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loading />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Admins can access manager routes
  if (isAdmin) {
    return children;
  }

  // Check if user is a manager
  if (!isManager) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You need manager permissions to access this page.
          </p>
          <a 
            href="/" 
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            Go back to home
          </a>
        </div>
      </div>
    );
  }

  // If there's a company context, check if manager belongs to this company
  if (companyId && managerCompanyId !== companyId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Wrong Company</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to manage this company.
          </p>
          <a 
            href="/" 
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            Go back to home
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ManagerRoute;
